/*
 * @Author: lzy
 * @Date: 2019-11-28 12:00:43
 * @LastEditTime: 2021-03-16 11:09:18
 * @LastEditors: lzy
 * @Description: 报题选题弹窗
 * @FilePath: \xjmediacloud\app\editingCenter\service\relatedReport\relatedReport.js
 */
'use strict';
angular.module('relatedReportModule', []).controller('relatedReportCtrl', ['$q', '$modalInstance', '$scope', 'selected', 'type', 'trsHttpService', '$sessionStorage',
    function($q, $modalInstance, $scope, selected, type, trsHttpService, $sessionStorage) {
        initStatus();
        initData();
        getStartTime();
        requestData();
        getReportGroup();

        /**
         * [initStatus description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
                PAGECOUNT: 0,
                ITEMCOUNT: 0,
            };
            $scope.status = {
                selectedArr: [], // 选中数组
                isTask: type === 'task',
                isSwitchReportAudit: $sessionStorage.get('curUserInfo').SWITCHREPORTAUDIT === 'true' // 代表是否打开选题审核
            };
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.data = {
                reportModelTitle: $scope.status.isSwitchReportAudit ? '报题' : '选题',
                todayDate: '',
                groupArr: [{
                    GNAME: $scope.status.isSwitchReportAudit ? '全部报题组' : '全部选题组',
                    GROUPID: '',
                }], // 报题分组
                selectedGroup: {}, // 选中的报题分组， 默认选中为空
                selectedReport: selected || {}, // 选中的报题对象，默认未空对象
                selectedTask: selected || {}, // 选中的任务对象，默认未空对象
                type: type || 'report', // 选中的类型 默认为选题
                typeArray: [
                    {
                        name: '全部报题',
                        value: '-1'
                    },
                    {
                        name: '已审报题',
                        value: '1'
                    },
                    {
                        name: '待审报题',
                        value: '0'
                    }
                ],
                selectedType: {
                    name: '全部报题',
                    value: '-1'
                }
            };
            $scope.params = {
                methodname: 'queryRelateReportByUser',
                serviceid: 'mlf_newreport',
                PageSize: $scope.page.PAGESIZE,
                PageIndex: $scope.page.CURRPAGE,
            };
            $scope.taskparams = {
                methodname: 'queryMyExecuted',
                serviceid: 'mlf_taskcommand',
                PageSize: $scope.page.PAGESIZE,
                Status: 3,
                CurrPage: $scope.page.CURRPAGE,
            };
        }

        /**
         * [function description]在发请求之前判断一下，是任务还是选题
         *
         * @return  {[type]}  [return description]
         */
        function dealParamsBeforeRequest() {
            if ($scope.status.isTask) {
                $scope.params = $scope.taskparams;
            } // else {
        //         $scope.params = {
        //             methodname: 'queryRelateReportByUser',
        //             serviceid: 'mlf_newreport',
        //             PageSize: $scope.page.PAGESIZE,
        //             PageIndex: $scope.page.CURRPAGE,
        //         };
        //     }
        }

        /**
         * [getReportGroup description] 请求报题选题列表
         * @return  {[type]}  [return description]
         */
        function requestData() {
            var defer = $q.defer();
            dealParamsBeforeRequest();
            // $scope.params.PageIndex = $scope.page.CURRPAGE,
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getReportGroup description] 请求报题分组
         * @return  {[type]}  [return description]
         */
        function getReportGroup() {
            var params = {
                methodname: 'queryOwnerGroup',
                serviceid: 'mlf_newreport',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.groupArr = $scope.data.groupArr.concat(data);
                $scope.data.selectedGroup = $scope.data.groupArr[0];
            });
        }

        /**
         * [getStartTime description] 获取今天的日期
         * @return  {[type]}  [return description]
         */
        function getStartTime() {
            var date = new Date();
            var month = date.getMonth() + 1;
            month = month > 9 ? month : '0' + month;
            var day = date.getDate();
            day = day > 9 ? day : '0' + day;
            $scope.data.todayDate = $scope.params.StartTime = $scope.params.EndTime = date.getFullYear() + '-' + month + '-' + day;
        }

        /**
         * [selectedReport description] 报题选择参数操作
         * @param   {[type]}  item  [item description] 选中的报题
         * @param   {[type]}  type  [type description] 选中的类型
         * @return  {[type]}  [return description]
         */
        $scope.selectedReport = function (item, type) {
            if (type === 'task') {
                if ($scope.data.selectedTask.TASKCOMMANDID === item.TASKCOMMANDID) {
                    $scope.data.selectedTask = {};
                } else {
                    $scope.data.selectedTask = item;
                }
            } else {
                if ($scope.data.selectedReport.NEWREPORTID === item.NEWREPORTID) {
                    $scope.data.selectedReport = {};
                } else {
                    $scope.data.selectedReport = item;
                }
            }
        };

        /**
         * [queryByCallback description] 搜索条件回掉
         * @param   {[String]}  type  [type description] 条件搜索类型
         * @param   {[String]}  value  [value description] 值
         * @return  {[type]}  [return description]
         */
        $scope.queryByCallback = function(type, value) {
            if (type !== 'timeType') {
                $scope.params[type] = value;
            } else {
                if (!$scope.params.StartTime || !$scope.params.EndTime) {
                    $scope.params.StartTime = $scope.params.EndTime = $scope.data.todayDate;
                }
            }
            $scope.page.CURRPAGE = 1;
            requestData();
        };

        /**
         *[close description] 取消按钮操作
        * @return  {[type]}  [return description]
        */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确定按钮操作
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function () {
            if ($scope.status.isTask) {
                $modalInstance.close({
                    data: $scope.data.selectedTask,
                });
            } else {
                $modalInstance.close({
                    data: $scope.data.selectedReport,
                });
            }
            
        };

        /**
         * [pageChanged description]翻页/跳页
         * 
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function () {
            if ($scope.status.isTask) {
                $scope.taskparams.CURRPAGE = $scope.page.CURRPAGE;
            } else {
                $scope.params.PageIndex = $scope.page.CURRPAGE;
            }
            requestData();
        };
    }
]);
